import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const cloudflareAnalyticsToken =
  process.env.REACT_APP_CLOUDFLARE_WEB_ANALYTICS_TOKEN;

if (
  cloudflareAnalyticsToken &&
  !document.querySelector('script[data-cf-beacon]')
) {
  const analyticsScript = document.createElement('script');
  analyticsScript.type = 'module';
  analyticsScript.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  analyticsScript.dataset.cfBeacon = JSON.stringify({
    token: cloudflareAnalyticsToken,
  });
  document.body.appendChild(analyticsScript);
}

// Find the root DOM element
const rootElement = document.getElementById('root');

// Ensure rootElement exists
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
